import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/main.scss';
import './index.css';
import App from './App';

// Force scroll to top on page load/reload
if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'manual';
}

window.onload = function() {
  window.scrollTo(0, 0);
};

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
